import { captureException } from "@sentry/react";
import { AxiosInstance, AxiosResponse } from "axios";
import { Dispatch } from "redux";
import { showNotification } from "../../notification/actions";

import { ADD_TASK } from "../types";
import { PlanActionTypes } from "../models/planActions";
import { IStateTree } from "../../interfaces";

interface IAddTaskResponse { limit?: number, success: boolean, id: number };

export default (data: { planId: string, index: number, taskType: string }, callback: (res: AxiosResponse<IAddTaskResponse>) => void) => 
    async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.post<IAddTaskResponse>("/add-task", data);
        dispatch({
            type: ADD_TASK,
            payload: { ...res, ...data },
        });
        callback(res);
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};
